import type { ConstructorClass } from "../../../../types/internal/utility";
import type { ApplicationAgent } from "./ApplicationAgent";
import { ApplicationManager } from "./ApplicationManager";

let manager: undefined | ApplicationManager;

export const getApplicationManager = (): ApplicationManager => {
    if(typeof manager === "undefined") {
        manager = new ApplicationManager();
    }

    return manager;
};

export const resetApplicationManager = (): void => {
    if(typeof manager !== "undefined") {
        manager.destroy();
    }

    manager = undefined;
};

export const createNewApplicationAgentForManager = (
    ...params: ConstructorParameters<typeof ApplicationAgent>
): ApplicationAgent => {
    if(typeof window === "undefined") {
        throw new Error("Invalid location to create an application");
    }

    if(
        !("__shopfront" in window) ||
        typeof window.__shopfront !== "object" ||
        window.__shopfront === null ||
        !("ApplicationAgent" in window.__shopfront)
    ) {
        throw new Error("Shopfront bootstrap hasn't been initialised in the correct order");
    }

    return new (window.__shopfront.ApplicationAgent as ConstructorClass<ApplicationAgent>)(
        ...params
    );
};
